<template>
  <div class="La1" :style="{
    gridTemplateColumns: ratio
  }">
    <div class="La1_left">
      <slot name="left"/>
      <div class="popup" v-if="popupL">
        <slot name="popupL"/>
      </div>
    </div>
    <div class="La1_right">
      <slot/>
      <div class="popup" v-if="popupR">
        <slot name="popupR"/>
      </div>
    </div>
    <div class="popup" v-if="popup">
      <slot name="popup"/>
    </div>
  </div>
</template>

<script>
export default {
  props: ['ratio', 'popup', 'popupL', 'popupR']

}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  .La1 {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 89px);
    display: grid;
    grid-template-columns: auto auto;
    grid-template-rows: 100%;
    gap: 29px;
    .La1_left {
      flex: 1 1 auto;
      overflow-y: auto;
      overflow: hidden;
    }
    .La1_right {
      flex: 1 1 auto;
      overflow: hidden;
    }
  }
}
.popup {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--backdrop);
  backdrop-filter: blur(5px);
  z-index: 200;

}
</style>
<style lang="scss" scoped>
@media screen and (orientation: portrait) {
  .La1 {
    display: flex;
    flex-direction: column;
  }
}
</style>
